import { FOOTER_ID } from '@constants/componentIds';
import { FooterBody } from '@common/Footer/containers/FooterBody';
import { FooterBottom } from '@common/Footer/containers/FooterBottom';
import { ReactOnRailsRootComponent } from '@common/ReactOnRails';

export function Footer({
    subFooterLinks,
    navigations,
    paymentMethodsIcons,
    paymentMethodsNavUrl,
    deliveryOptionsIcons,
    deliveryOptionsNavUrl,
    securityShoppingIcons,
    socialLinks,
    appLinks,
    languages
}) {
    return (
        <footer id={FOOTER_ID}>
            <FooterBody
                appLinks={appLinks}
                deliveryOptionsIcons={deliveryOptionsIcons}
                deliveryOptionsNavUrl={deliveryOptionsNavUrl}
                languages={languages}
                navigations={navigations}
                paymentMethodsIcons={paymentMethodsIcons}
                paymentMethodsNavUrl={paymentMethodsNavUrl}
                socialLinks={socialLinks}
            />
            <FooterBottom
                securityShoppingIcons={securityShoppingIcons}
                subFooterLinks={subFooterLinks}
            />
        </footer>
    );
}

export const FooterStandalone = ReactOnRailsRootComponent(Footer, { withReduxStore: true });
